export default "__VITE_ASSET__474da562__"